import classNames from 'classnames';
import { forwardRef } from 'react';
import styled from 'styled-components';

import { Game, Props as GameProps } from './Game';

const Root = styled.div`
  & > *:not(:last-child) {
    border-bottom: 1px solid var(--c-black);
  }

  &.roundedTop {
    & > *:first-child {
      border-top-right-radius: var(--double-unit);
      border-top-left-radius: var(--double-unit);
    }
  }

  & > *:last-child {
    border-bottom-right-radius: var(--double-unit);
    border-bottom-left-radius: var(--double-unit);
  }
`;

type Props = {
  games: GameProps['game'][];
  hideGameWeek?: boolean;
  roundedTop?: boolean;
};

export const Games = forwardRef<HTMLDivElement, Props>(
  ({ games, hideGameWeek, roundedTop }, ref) => {
    return (
      <Root ref={ref} className={classNames({ roundedTop })}>
        {games.map(game => (
          <Game key={game.id} hideGameWeek={hideGameWeek} game={game} />
        ))}
      </Root>
    );
  }
);

Games.displayName = 'Games';
